// Sala 360 · textos em pt, en e es (mesmas chaves). Nenhum rótulo fica no componente.
const pt = {
  m4: {
    negocios: '{{n}} negócios no acesso', setor: 'Setor', setorAusente: 'Setor não informado',
    cobertura: '{{n}} de {{m}} empresas', coberturaAusente: 'Cobertura não informada',
    dadoDe: 'Dado de', dadoAusente: 'Corte do dado não informado pela fonte', lidoEm: 'Lido em',
    maturidade: 'Maturidade', maturidadeAusente: 'Não definida',
    corteCelula: 'Corte: {{data}}', responsavelCelula: 'Responsável: {{nome}}',
    pendencias: 'Pendências autorizadas', pendenciasValor: '{{n}} registro(s) · {{valor}}',
    pendenciasAusentes: 'Pendências indisponíveis nesta fatia', semPendencias: 'A fonte informa nenhuma pendência',
    kpis: 'Indicadores afetados', kpisAusentes: 'Indicadores afetados não informados',
    composicao: 'Composição por origem', titulos: 'Títulos', pedidos: 'Pedidos', manuais: 'Manuais',
    incluidaNoAgregado: 'Incluído no agregado do Financeiro', naoIncluida: 'Não incluído no K04 nesta fatia',
    separacaoIndisponivel: 'Separação indisponível nesta fatia.',
    titulosInformativos: 'Detalhamento informativo de títulos, já incluído no agregado do Financeiro; não deve ser somado novamente.',
    detalhamentoTitulosAusente: 'Detalhamento de títulos indisponível nesta fatia.',
    entradasTitulos: 'Entradas de títulos', saidasTitulos: 'Saídas de títulos',
    composicaoAusente: 'Composição não informada pela fonte',
    pedirAdmin: 'Peça ao administrador do workspace para configurar a fonte.',
    pedirAcesso: 'Peça ao administrador do workspace para revisar seu acesso.',
    semAcesso: 'Nenhuma empresa no seu acesso. Peça ao administrador do workspace para revisar seu acesso.',
    falhaLinha: 'Não foi possível montar esta linha. Tente atualizar as fontes.',
    atualizar: 'Atualizar fontes',
    falhaPendencias: 'Não foi possível ler as pendências. Os dados principais da fonte foram preservados.',
    tentarPendencias: 'Tentar ler pendências novamente',
  },
  abas: { resumo: 'Resumo', decisoes: 'Decisões', fontes: "Fontes e cobertura" },
  fontes: {
    "titulo": "Fontes e cobertura",
    "descricao": "Veja a origem e a condição de leitura dos processos no seu acesso.",
    "matriz": "Cobertura por empresa e processo",
    "resumo": "{{n}} de {{m}} fontes atuais",
    "abrir": "{{empresa}} · {{processo}} · {{estado}}",
    "vazio": "Nenhuma fonte cadastrada neste recorte.",
    "vazioTexto": "O administrador da Sala 360 pode configurar as fontes das empresas no seu acesso.",
    "negado": "Parcial por permissão.",
    "legenda": "Legenda",
    "estadosFonte": "Estados da fonte",
    "precondicoes": "Pré-condições para leitura",
    "origem": "Origem",
    "sistema": "Sistema",
    "responsavel": "Responsável",
    "responsavelId": "Identificador do responsável",
    "responsavelAjuda": "Opcional. Informe o identificador de um membro ativo com acesso à empresa; a validação é feita ao salvar.",
    "ultimaLeitura": "Última leitura",
    "limite": "Limite de validade",
    "limiteCampo": "Limite de validade (horas)",
    "horas": "{{n}} horas",
    "estadoRotulo": "Estado",
    "motivo": "Motivo",
    "motivoAjuda": "Explicação do estado da fonte; o sistema de origem não fornece um diagnóstico detalhado nesta tela.",
    "escopoAlterado": "O acesso mudou durante a ação. Atualize as fontes antes de tentar novamente.",
    "semInformacao": "Não informado",
    "semLeitura": "Ainda não houve leitura.",
    "corte": "Corte {{data}} (Brasília)",
    "cadastrar": "Cadastrar fonte",
    "alterar": "Alterar fonte",
    "salvar": "Salvar fonte",
    "salvando": "Salvando fonte",
    "cancelar": "Cancelar",
    "salva": "Fonte salva.",
    "registrarLeitura": "Registrar leitura",
    "registrandoLeitura": "Registrando leitura",
    "resultadoLeitura": "Resultado da leitura",
    "processo": "Processo",
    "escolhaResultado": "Escolha o resultado",
    "leituraAjuda": "Registre o resultado já apurado. Esta ação usa o horário do servidor e não consulta o sistema de origem.",
    "leituraRegistrada": "Leitura registrada.",
    "fonteIndisponivel": "Fonte indisponível no seu acesso.",
    "revogar": "Acesso à fonte revogado",
    "revogarAjuda": "Ao retirar esta marca, a fonte exige uma nova leitura antes de ficar atual.",
    "corrija": "Corrija os campos para salvar a fonte.",
    "voltar": "Voltar ao resumo",
    "fonteNaoConfigurada": "Configure uma fonte e registre a primeira leitura para este processo.",
    "leituraBloqueada": "Configure e habilite a fonte antes de registrar uma leitura.",
    dadoDeAjuda: 'Opcional. Informe a data efetiva do dado publicado pela fonte; deixe vazio quando a fonte não informar.',
    maturidadeAjuda: 'Opcional. Registre somente a maturidade declarada pela fonte.',
    solicitarResponsavel: 'Solicitar responsável',
    solicitandoResponsavel: 'Registrando solicitação',
    solicitacaoDestino: 'Destino: administradores deste workspace. A solicitação fica registrada na Sala 360.',
    responsavelSolicitado: 'Solicitação registrada. Aguarde a definição do responsável pelos administradores deste workspace.',
    solicitacaoFalhou: 'Não foi possível registrar a solicitação. Tente novamente.',
    responsavelJaDefinido: 'Um responsável já foi definido. Atualize as fontes para consultar a configuração.',
    pendenciasResponsavel: 'Solicitações de responsável pendentes',
    pendenciaResponsavel: '{{n}} solicitação(ões) de responsável pendente(s)',
    abrirPendenciaResponsavel: '{{empresa}} · {{processo}} · {{n}} solicitação(ões) pendente(s)',
    maturidadeRotulo: { informado: 'Informado', conferido: 'Conferido', conciliado: 'Conciliado' },
    "semResponsavel": "Responsável ainda não definido.",
    "estado": {
      "nao_configurada": "Não configurada",
      "sem_leitura": "Sem leitura"
    },
    "origemRotulo": {
      "erp": "ERP",
      "externo": "Sistema externo",
      "arquivo": "Arquivo",
      "sem_fonte": "Sem fonte"
    },
    "motivoEstado": {
      "negado": "Os dados desta empresa não estão disponíveis ao seu perfil.",
      "falha": "A última tentativa de leitura falhou. Dados antigos não devem ser tratados como atuais.",
      "revogada": "O acesso à fonte foi revogado. É necessário habilitá-lo e registrar uma nova leitura.",
      "com_diferenca": "A leitura informa diferença que precisa ser conferida na origem.",
      "vencida": "A última leitura ultrapassou o limite de validade configurado.",
      "parcial": "A leitura cobre somente parte dos dados deste processo.",
      "atual": "A última leitura está dentro do limite de validade configurado.",
      "nao_configurada": "Falta configurar a origem deste processo.",
      "sem_leitura": "A fonte está configurada, mas falta registrar a primeira leitura."
    }
  },
  portfolio: {
    "titulo": "Mapa dos negócios",
    "mostrar": "Mostrar cobertura dos negócios",
    "ocultar": "Ocultar cobertura dos negócios",
    "negocio": "Negócio",
    "empresas": "Empresas no acesso",
    "processos": "Processos cobertos",
    "cobertura": "Cobertura",
    "fonte": "Estado da fonte",
    "institucional": "Institucional",
    "institucionalDescricao": "Informações institucionais, sem números operacionais.",
    "vazio": "Nenhum negócio disponível neste perímetro.",
    "nenhumaFonte": "Nenhum processo com fonte atual.",
    "faltam": "Sem fonte: {{lista}}",
    "parcialPermissao": "Parcial por permissão.",
    "quantidade": "{{n}} empresa(s) no acesso",
    "estados": {
      "coberto": "Coberto",
      "parcial": "Parcial",
      "sem_fonte": "Sem fonte",
      "fora_do_acesso": "Fora do seu acesso"
    }
  },
  demo: { selo: 'Demonstração, dados sintéticos', verificando: 'Verificando o ambiente' },
  resumo: {
    kicker: 'Sala 360',
    titulo: 'Resumo executivo',
    perimetro: 'Empresas do workspace {{workspace}}: {{n}} de {{m}}',
    corte: 'Corte {{data}} (Brasília)',
    contexto: 'Empresa',
    todas: 'Todas as empresas do acesso',
    semEmpresas: 'Nenhuma empresa no seu acesso',
    janela: 'Janela',
    dias: '{{n}} dias',
    proposto: 'Fórmulas propostas, pendentes de validação da controladoria',
  },
  kpi: {
    K01: 'Caixa próprio no corte',
    K02: 'A pagar na janela',
    K03: 'A receber vencido',
    K05: 'Decisões abertas',
    K04: "Caixa projetado (30 dias)",
    origemK04: "Origem: Financeiro e Contas",
    origemK05: 'Origem: Sala 360',
    origemK01: 'Origem: Financeiro',
    origemK02: 'Origem: Contas e Compras',
    origemK03: 'Origem: Contas',
  },
  estado: {
    atual: 'Atual', parcial: 'Parcial', vencida: 'Vencida', com_diferenca: 'Com diferença', revogada: 'Acesso revogado',
    falha: 'Falha de leitura', negado: 'Fora do seu acesso', indisponivel: 'Indisponível',
  },
  cartao: {
    semDado: 'sem dado',
    semRegistros: 'Sem registros: a fonte informa zero',
    parcela: 'Parcela conhecida',
    faltam: 'Falta: {{lista}}',
    indisponivel: 'Sem fonte para este indicador.',
    negado: 'Parcial por permissão.',
    falha: 'Não foi possível ler este indicador.',
    vencida: 'Dado de {{data}}, além do limite.',
    naoConciliado: 'Não conciliado',
    pendenteClassificacao: 'Pendente de classificação',
    foraDoK01: 'Restritas e administradas (fora do K01)',
    pedidosSemTitulo: 'Pedidos sem título (fora do total)',
    pendenciaMapeamento: 'Pendência de mapeamento: {{n}} título(s) sem empresa',
    tentar: 'Tentar de novo',
    cobertura: 'Cobertura: {{n}} de {{m}} empresas',
    naoAgregavel: "Não agregável: cobertura insuficiente para a projeção completa.",
    verFontes: "Ver fontes e cobertura",
    projecao: "Previsto em 30 dias",
    formulaProjecao: "Saldo próprio de abertura + entradas previstas − saídas previstas",
    abertura: "Saldo próprio de abertura",
    entradas: "Entradas previstas",
    saidas: "Saídas previstas",
    vencidosProjecao: "Vencidos em aberto incluídos no primeiro período: {{n}}",
  },
  processo: { bancos: 'bancos', natureza: 'natureza das contas', pagar: 'contas a pagar', pedidos: 'pedidos de compra', receber: 'contas a receber', decisoes: 'decisões' },
  compromissos: {
    titulo: 'Compromissos',
    pagar: 'A pagar',
    receber: 'A receber',
    numero: 'Número',
    empresa: 'Empresa',
    parceiro: 'Contraparte',
    vencimento: 'Vencimento',
    valor: 'Saldo',
    vinculo: 'Pedido',
    confirmado: 'Pedido {{numero}}',
    ausente: 'Sem pedido',
    vencido: 'Vencido',
    grupo: 'Grupo (sem empresa)',
    vazio: 'A fonte informa que não há compromissos nesta janela.',
    exportar: 'Exportar CSV',
    mais: 'Carregar mais',
    pedidoSemTitulo: 'Pedido sem título',
    previsao: 'Previsão {{data}}',
    abrir: 'Abrir compromisso {{numero}}',
  },
  detalhe: {
    kicker: 'Compromisso',
    voltar: 'Voltar ao resumo',
    cadeia: 'Pedido, título e pagamento',
    pedido: 'Pedido',
    titulo: 'Título',
    pagamento: 'Pagamento',
    noConfirmado: 'confirmado',
    noAusente: 'não vinculado',
    emissao: 'Emissão',
    total: 'Total',
    pago: 'Pago',
    saldo: 'Saldo',
    estado: 'Estado',
    descricao: 'Descrição',
    restrito: 'Parte das informações não está disponível ao seu perfil.',
    evidencias: 'Ver evidências',
    decidir: 'Registrar decisão sobre este título',
    baixa: 'Baixa em {{data}}',
    estados: { em_aberto: 'Em aberto', parcial: 'Parcial', pago: 'Pago', cancelado: 'Cancelado', renegociado: 'Renegociado' },
  },
  evidencias: {
    kicker: 'Evidências',
    titulo: 'Evidências de {{numero}}',
    vazio: 'Nenhuma evidência vinculada a este compromisso.',
    restritas: 'Há evidências que não estão disponíveis ao seu perfil.',
    registro: 'Registro de origem',
    anexo: 'Anexo',
    abrir: 'Abrir',
    baixar: 'Baixar',
    voltar: 'Voltar ao compromisso',
    entidades: { 'contas.documento': 'Título em Contas', 'compras.pedido': 'Pedido em Compras' },
    semVisualizacao: 'Este formato não abre aqui. Use Baixar.',
    falhaLeitura: 'Não foi possível abrir o anexo.',
    suporte: 'Código para o suporte: {{codigo}}',
    fechar: 'Fechar',
  },
  decisoes: {
    kicker: 'Decisão', voltar: 'Voltar à fila', recortes: 'Recortes da fila', registrar: 'Registrar decisão', registrada: 'Decisão registrada.',
    recorte: { minhas: 'Minhas', abertas_por_mim: 'Que eu abri', encerradas: 'Encerradas' },
    vazio: { minhas: 'Nenhuma decisão aberta sob sua responsabilidade.', abertas_por_mim: 'Nenhuma decisão aberta por você.', encerradas: 'Nenhuma decisão encerrada.' },
    vencidaHa_one: 'Vencida há {{count}} dia', vencidaHa_other: 'Vencida há {{count}} dias',
    contadorVencidas_one: '{{count}} decisão vencida no topo da fila', contadorVencidas_other: '{{count}} decisões vencidas no topo da fila',
    objeto: { 'contas.documento': 'Título', 'compras.pedido': 'Pedido de compra', livre: 'Decisão livre' },
    estado: { aberta: 'Aberta', em_andamento: 'Em andamento', concluida: 'Concluída', cancelada: 'Cancelada' },
    evento: { criada: 'Registrada', em_andamento: 'Em andamento', concluida: 'Concluída com resultado confirmado', cancelada: 'Cancelada', prazo_vencido: 'Prazo vencido' },
    acao: { andamento: 'Marcar em andamento', concluir: 'Concluir', cancelar: 'Cancelar decisão' },
    responsavel: 'Responsável', solicitante: 'Aberta por', prazo: 'Prazo', titulo: 'Título', oQue: 'O que foi decidido', sobre: 'Sobre',
    estadoRotulo: 'Estado', resultado: 'Resultado confirmado', motivo: 'Motivo', obrigatorio: 'obrigatório', conduzir: 'Conduzir a decisão',
    ajudaConcluir: 'Concluir só fica disponível com o resultado confirmado preenchido.', historico: 'Histórico',
    escolha: 'Escolha o responsável', ninguem: 'Ninguém com acesso a este objeto', prazoPassado: 'O prazo não pode ser anterior a hoje.',
    salvar: 'Registrar', salvando: 'Registrando', cancelarForm: 'Cancelar', naoEncontrada: 'Decisão não encontrada.',
    conflito: 'Outra pessoa alterou esta decisão agora. A tela foi atualizada.', corrija: 'Corrija para registrar:', proximas: 'Decisões mais próximas', semAbertas: 'Nenhuma decisão aberta.', verTodas: 'Ver todas as decisões', vencidas: 'Vencidas: {{n}}',
  },
  chatter: { prazoVencido: 'Prazo vencido: {{titulo}}' },
  erros: {
    prazo_no_passado: 'O prazo não pode ser anterior a hoje.', titulo_invalido: 'Informe um título de até 160 caracteres.',
    decisao_invalida: 'Descreva a decisão (até 2000 caracteres).', responsavel_sem_acesso: 'O responsável precisa ter acesso à empresa do objeto.',
    objeto_indisponivel: 'Objeto não encontrado.', empresa_indisponivel: 'Empresa não encontrada.',
    fonte_sem_configuracao: "Configure e habilite a fonte antes de registrar a leitura.",
    limite_invalido: "Informe um número inteiro positivo de horas.",
    sistema_invalido: "Informe um sistema de até 160 caracteres.",
    origem_invalida: "Escolha uma origem válida.",
    processo_invalido: "Escolha um processo da Sala 360.",
    leitura_invalida: "Escolha um resultado de leitura válido.",
    dado_de_invalido: 'Informe uma data válida no formato ano-mês-dia.', maturidade_invalida: 'Escolha uma maturidade válida.',
    fonte_nao_encontrada: "Fonte indisponível no seu acesso.",
  },
  erro: { semPermissao: 'Você não tem acesso à Sala 360.', naoEncontrado: 'Compromisso não encontrado.' },
};

export type Dic = typeof pt;

const en: Dic = {
  m4: {
    negocios: '{{n}} businesses in your access', setor: 'Sector', setorAusente: 'Sector not provided',
    cobertura: '{{n}} of {{m}} companies', coberturaAusente: 'Coverage not provided',
    dadoDe: 'Data as of', dadoAusente: 'Source does not provide a data cutoff', lidoEm: 'Read at',
    maturidade: 'Maturity', maturidadeAusente: 'Not defined',
    corteCelula: 'Cutoff: {{data}}', responsavelCelula: 'Owner: {{nome}}',
    pendencias: 'Authorized pending items', pendenciasValor: '{{n}} record(s) · {{valor}}',
    pendenciasAusentes: 'Pending items unavailable in this slice', semPendencias: 'Source reports no pending items',
    kpis: 'Affected indicators', kpisAusentes: 'Affected indicators not provided',
    composicao: 'Composition by origin', titulos: 'Documents', pedidos: 'Orders', manuais: 'Manual entries',
    incluidaNoAgregado: 'Included in the Finance aggregate', naoIncluida: 'Not included in K04 in this slice',
    separacaoIndisponivel: 'Separate figures are unavailable in this slice.',
    titulosInformativos: 'Informational document detail, already included in the Finance aggregate; do not add it again.',
    detalhamentoTitulosAusente: 'Document detail is unavailable in this slice.',
    entradasTitulos: 'Document inflows', saidasTitulos: 'Document outflows',
    composicaoAusente: 'Source does not provide composition',
    pedirAdmin: 'Ask the workspace administrator to configure the source.',
    pedirAcesso: 'Ask the workspace administrator to review your access.',
    semAcesso: 'No companies in your access. Ask the workspace administrator to review your access.',
    falhaLinha: 'This row could not be assembled. Try refreshing sources.',
    atualizar: 'Refresh sources',
    falhaPendencias: 'Could not read pending items. The main source data was preserved.',
    tentarPendencias: 'Retry pending items',
  },
  abas: { resumo: 'Summary', decisoes: 'Decisions', fontes: "Sources and coverage" },
  fontes: {
    "titulo": "Sources and coverage",
    "descricao": "Check the source and read status of processes in your access.",
    "matriz": "Coverage by company and process",
    "resumo": "{{n}} of {{m}} current sources",
    "abrir": "{{empresa}} · {{processo}} · {{estado}}",
    "vazio": "No sources registered in this scope.",
    "vazioTexto": "The 360 Room administrator can configure sources for companies in your access.",
    "negado": "Partial due to permissions.",
    "legenda": "Legend",
    "estadosFonte": "Source states",
    "precondicoes": "Read prerequisites",
    "origem": "Source",
    "sistema": "System",
    "responsavel": "Owner",
    "responsavelId": "Owner identifier",
    "responsavelAjuda": "Optional. Enter the identifier of an active member with company access; it is validated on save.",
    "ultimaLeitura": "Last read",
    "limite": "Freshness limit",
    "limiteCampo": "Freshness limit (hours)",
    "horas": "{{n}} hours",
    "estadoRotulo": "Status",
    "motivo": "Reason",
    "motivoAjuda": "Explanation of the source state; the source system does not provide a detailed diagnosis on this screen.",
    "escopoAlterado": "Access changed during the action. Refresh sources before trying again.",
    "semInformacao": "Not provided",
    "semLeitura": "No read has been recorded yet.",
    "corte": "Cutoff {{data}} (Brasília)",
    "cadastrar": "Register source",
    "alterar": "Edit source",
    "salvar": "Save source",
    "salvando": "Saving source",
    "cancelar": "Cancel",
    "salva": "Source saved.",
    "registrarLeitura": "Record read",
    "registrandoLeitura": "Recording read",
    "resultadoLeitura": "Read result",
    "processo": "Process",
    "escolhaResultado": "Choose the result",
    "leituraAjuda": "Record the result already obtained. This action uses server time and does not query the source system.",
    "leituraRegistrada": "Read recorded.",
    "fonteIndisponivel": "Source unavailable in your access.",
    "revogar": "Source access revoked",
    "revogarAjuda": "After clearing this option, a new read is required before the source becomes current.",
    "corrija": "Correct the fields to save the source.",
    "voltar": "Back to summary",
    "fonteNaoConfigurada": "Configure a source and record the first read for this process.",
    "leituraBloqueada": "Configure and enable the source before recording a read.",
    dadoDeAjuda: 'Optional. Enter the effective date of the data published by the source; leave it blank when the source does not provide it.',
    maturidadeAjuda: 'Optional. Record only the maturity declared by the source.',
    solicitarResponsavel: 'Request an owner',
    solicitandoResponsavel: 'Recording request',
    solicitacaoDestino: 'Destination: administrators of this workspace. The request is recorded in Sala 360.',
    responsavelSolicitado: 'Request recorded. Wait for the administrators of this workspace to assign an owner.',
    solicitacaoFalhou: 'The request could not be recorded. Try again.',
    responsavelJaDefinido: 'An owner has already been assigned. Refresh the sources to view the configuration.',
    pendenciasResponsavel: 'Pending owner requests',
    pendenciaResponsavel: '{{n}} pending owner request(s)',
    abrirPendenciaResponsavel: '{{empresa}} · {{processo}} · {{n}} pending request(s)',
    maturidadeRotulo: { informado: 'Reported', conferido: 'Checked', conciliado: 'Reconciled' },
    "semResponsavel": "Owner not assigned yet.",
    "estado": {
      "nao_configurada": "Not configured",
      "sem_leitura": "No read"
    },
    "origemRotulo": {
      "erp": "ERP",
      "externo": "External system",
      "arquivo": "File",
      "sem_fonte": "No source"
    },
    "motivoEstado": {
      "negado": "This company’s data is not available to your profile.",
      "falha": "The last read attempt failed. Previous data must not be treated as current.",
      "revogada": "Source access was revoked. Enable it and record a new read.",
      "com_diferenca": "The read reports a mismatch that needs checking at the source.",
      "vencida": "The last read exceeded the configured freshness limit.",
      "parcial": "The read covers only part of this process’s data.",
      "atual": "The last read is within the configured freshness limit.",
      "nao_configurada": "The source for this process needs configuration.",
      "sem_leitura": "The source is configured but its first read has not been recorded."
    }
  },
  portfolio: {
    "titulo": "Business coverage map",
    "mostrar": "Show business coverage",
    "ocultar": "Hide business coverage",
    "negocio": "Business",
    "empresas": "Companies in your access",
    "processos": "Covered processes",
    "cobertura": "Coverage",
    "fonte": "Source state",
    "institucional": "Institutional",
    "institucionalDescricao": "Institutional information, without operational figures.",
    "vazio": "No business available in this scope.",
    "nenhumaFonte": "No process with a current source.",
    "faltam": "No source: {{lista}}",
    "parcialPermissao": "Partial due to permissions.",
    "quantidade": "{{n}} company/companies in your access",
    "estados": {
      "coberto": "Covered",
      "parcial": "Partial",
      "sem_fonte": "No source",
      "fora_do_acesso": "Outside your access"
    }
  },
  demo: { selo: 'Demonstration, synthetic data', verificando: 'Checking the environment' },
  resumo: {
    kicker: '360 Room',
    titulo: 'Executive summary',
    perimetro: 'Companies in workspace {{workspace}}: {{n}} of {{m}}',
    corte: 'Cutoff {{data}} (Brasília)',
    contexto: 'Company',
    todas: 'All companies in your access',
    semEmpresas: 'No companies in your access',
    janela: 'Window',
    dias: '{{n}} days',
    proposto: 'Proposed formulas, pending controllership validation',
  },
  kpi: {
    K01: 'Own cash at cutoff',
    K02: 'Payables in the window',
    K03: 'Overdue receivables',
    K05: 'Open decisions',
    K04: "Projected cash (30 days)",
    origemK04: "Source: Finance and Payables/Receivables",
    origemK05: 'Source: 360 Room',
    origemK01: 'Source: Finance',
    origemK02: 'Source: Payables and Purchasing',
    origemK03: 'Source: Receivables',
  },
  estado: {
    atual: 'Current', parcial: 'Partial', vencida: 'Stale', com_diferenca: 'Mismatch', revogada: 'Access revoked',
    falha: 'Read failure', negado: 'Outside your access', indisponivel: 'Unavailable',
  },
  cartao: {
    semDado: 'no data',
    semRegistros: 'No records: the source reports zero',
    parcela: 'Known portion',
    faltam: 'Missing: {{lista}}',
    indisponivel: 'No source for this indicator.',
    negado: 'Partial due to permissions.',
    falha: 'This indicator could not be read.',
    vencida: 'Data from {{data}}, past the limit.',
    naoConciliado: 'Not reconciled',
    pendenteClassificacao: 'Pending classification',
    foraDoK01: 'Restricted and managed (outside K01)',
    pedidosSemTitulo: 'Orders without a bill (outside the total)',
    pendenciaMapeamento: 'Mapping pending: {{n}} bill(s) without a company',
    tentar: 'Try again',
    cobertura: 'Coverage: {{n}} of {{m}} companies',
    naoAgregavel: "Not aggregable: insufficient coverage for the complete projection.",
    verFontes: "View sources and coverage",
    projecao: "Forecast over 30 days",
    formulaProjecao: "Own opening balance + forecast inflows − forecast outflows",
    abertura: "Own opening balance",
    entradas: "Forecast inflows",
    saidas: "Forecast outflows",
    vencidosProjecao: "Open overdue items included in the first period: {{n}}",
  },
  processo: { bancos: 'banks', natureza: 'account nature', pagar: 'payables', pedidos: 'purchase orders', receber: 'receivables', decisoes: 'decisions' },
  compromissos: {
    titulo: 'Commitments',
    pagar: 'Payables',
    receber: 'Receivables',
    numero: 'Number',
    empresa: 'Company',
    parceiro: 'Counterparty',
    vencimento: 'Due date',
    valor: 'Balance',
    vinculo: 'Order',
    confirmado: 'Order {{numero}}',
    ausente: 'No order',
    vencido: 'Overdue',
    grupo: 'Group (no company)',
    vazio: 'The source reports no commitments in this window.',
    exportar: 'Export CSV',
    mais: 'Load more',
    pedidoSemTitulo: 'Order without a bill',
    previsao: 'Expected {{data}}',
    abrir: 'Open commitment {{numero}}',
  },
  detalhe: {
    kicker: 'Commitment',
    voltar: 'Back to summary',
    cadeia: 'Order, bill and payment',
    pedido: 'Order',
    titulo: 'Bill',
    pagamento: 'Payment',
    noConfirmado: 'confirmed',
    noAusente: 'not linked',
    emissao: 'Issued',
    total: 'Total',
    pago: 'Paid',
    saldo: 'Balance',
    estado: 'Status',
    descricao: 'Description',
    restrito: 'Part of this information is not available to your profile.',
    evidencias: 'View evidence',
    decidir: 'Record a decision on this bill',
    baixa: 'Payment on {{data}}',
    estados: { em_aberto: 'Open', parcial: 'Partial', pago: 'Paid', cancelado: 'Cancelled', renegociado: 'Renegotiated' },
  },
  evidencias: {
    kicker: 'Evidence',
    titulo: 'Evidence for {{numero}}',
    vazio: 'No evidence linked to this commitment.',
    restritas: 'Some evidence is not available to your profile.',
    registro: 'Source record',
    anexo: 'Attachment',
    abrir: 'Open',
    baixar: 'Download',
    voltar: 'Back to commitment',
    entidades: { 'contas.documento': 'Bill in Payables', 'compras.pedido': 'Order in Purchasing' },
    semVisualizacao: 'This format does not open here. Use Download.',
    falhaLeitura: 'The attachment could not be opened.',
    suporte: 'Support code: {{codigo}}',
    fechar: 'Close',
  },
  decisoes: {
    kicker: 'Decision', voltar: 'Back to the queue', recortes: 'Queue views', registrar: 'Record decision', registrada: 'Decision recorded.',
    recorte: { minhas: 'Mine', abertas_por_mim: 'Opened by me', encerradas: 'Closed' },
    vazio: { minhas: 'No open decision under your responsibility.', abertas_por_mim: 'No open decision opened by you.', encerradas: 'No closed decision.' },
    vencidaHa_one: 'Overdue by {{count}} day', vencidaHa_other: 'Overdue by {{count}} days',
    contadorVencidas_one: '{{count}} overdue decision at the top of the queue', contadorVencidas_other: '{{count}} overdue decisions at the top of the queue',
    objeto: { 'contas.documento': 'Bill', 'compras.pedido': 'Purchase order', livre: 'Free decision' },
    estado: { aberta: 'Open', em_andamento: 'In progress', concluida: 'Completed', cancelada: 'Cancelled' },
    evento: { criada: 'Recorded', em_andamento: 'In progress', concluida: 'Completed with confirmed result', cancelada: 'Cancelled', prazo_vencido: 'Deadline passed' },
    acao: { andamento: 'Mark in progress', concluir: 'Complete', cancelar: 'Cancel decision' },
    responsavel: 'Owner', solicitante: 'Opened by', prazo: 'Deadline', titulo: 'Title', oQue: 'What was decided', sobre: 'About',
    estadoRotulo: 'Status', resultado: 'Confirmed result', motivo: 'Reason', obrigatorio: 'required', conduzir: 'Move the decision forward',
    ajudaConcluir: 'Complete is only available once the confirmed result is filled in.', historico: 'History',
    escolha: 'Choose the owner', ninguem: 'Nobody with access to this object', prazoPassado: 'The deadline cannot be before today.',
    salvar: 'Record', salvando: 'Recording', cancelarForm: 'Cancel', naoEncontrada: 'Decision not found.',
    conflito: 'Someone else just changed this decision. The screen was refreshed.', corrija: 'Fix to record:', proximas: 'Nearest decisions', semAbertas: 'No open decision.', verTodas: 'See all decisions', vencidas: 'Overdue: {{n}}',
  },
  chatter: { prazoVencido: 'Deadline passed: {{titulo}}' },
  erros: {
    prazo_no_passado: 'The deadline cannot be before today.', titulo_invalido: 'Enter a title of up to 160 characters.',
    decisao_invalida: 'Describe the decision (up to 2000 characters).', responsavel_sem_acesso: 'The owner must have access to the object\'s company.',
    objeto_indisponivel: 'Object not found.', empresa_indisponivel: 'Company not found.',
    fonte_sem_configuracao: "Configure and enable the source before recording a read.",
    limite_invalido: "Enter a positive integer number of hours.",
    sistema_invalido: "Enter a system name of up to 160 characters.",
    origem_invalida: "Choose a valid source.",
    processo_invalido: "Choose a 360 Room process.",
    leitura_invalida: "Choose a valid read result.",
    dado_de_invalido: 'Enter a valid date in year-month-day format.', maturidade_invalida: 'Choose a valid maturity.',
    fonte_nao_encontrada: "Source unavailable in your access.",
  },
  erro: { semPermissao: 'You do not have access to the 360 Room.', naoEncontrado: 'Commitment not found.' },
};

const es: Dic = {
  m4: {
    negocios: '{{n}} negocios en su acceso', setor: 'Sector', setorAusente: 'Sector no informado',
    cobertura: '{{n}} de {{m}} empresas', coberturaAusente: 'Cobertura no informada',
    dadoDe: 'Datos del', dadoAusente: 'La fuente no informa el corte del dato', lidoEm: 'Leído el',
    maturidade: 'Madurez', maturidadeAusente: 'No definida',
    corteCelula: 'Corte: {{data}}', responsavelCelula: 'Responsable: {{nome}}',
    pendencias: 'Pendientes autorizados', pendenciasValor: '{{n}} registro(s) · {{valor}}',
    pendenciasAusentes: 'Pendientes no disponibles en esta parte', semPendencias: 'La fuente informa que no hay pendientes',
    kpis: 'Indicadores afectados', kpisAusentes: 'Indicadores afectados no informados',
    composicao: 'Composición por origen', titulos: 'Títulos', pedidos: 'Pedidos', manuais: 'Manuales',
    incluidaNoAgregado: 'Incluido en el agregado de Finanzas', naoIncluida: 'No incluido en K04 en esta parte',
    separacaoIndisponivel: 'Desglose no disponible en esta parte.',
    titulosInformativos: 'Detalle informativo de títulos, ya incluido en el agregado de Finanzas; no debe sumarse de nuevo.',
    detalhamentoTitulosAusente: 'Detalle de títulos no disponible en esta parte.',
    entradasTitulos: 'Entradas de títulos', saidasTitulos: 'Salidas de títulos',
    composicaoAusente: 'La fuente no informa la composición',
    pedirAdmin: 'Pida al administrador del workspace que configure la fuente.',
    pedirAcesso: 'Pida al administrador del workspace que revise su acceso.',
    semAcesso: 'No hay empresas en su acceso. Pida al administrador del workspace que revise su acceso.',
    falhaLinha: 'No se pudo montar esta fila. Intente actualizar las fuentes.',
    atualizar: 'Actualizar fuentes',
    falhaPendencias: 'No se pudieron leer los pendientes. Se conservaron los datos principales de la fuente.',
    tentarPendencias: 'Volver a leer pendientes',
  },
  abas: { resumo: 'Resumen', decisoes: 'Decisiones', fontes: "Fuentes y cobertura" },
  fontes: {
    "titulo": "Fuentes y cobertura",
    "descricao": "Consulte el origen y el estado de lectura de los procesos en su acceso.",
    "matriz": "Cobertura por empresa y proceso",
    "resumo": "{{n}} de {{m}} fuentes actuales",
    "abrir": "{{empresa}} · {{processo}} · {{estado}}",
    "vazio": "Ninguna fuente registrada en este ámbito.",
    "vazioTexto": "El administrador de Sala 360 puede configurar fuentes de las empresas en su acceso.",
    "negado": "Parcial por permisos.",
    "legenda": "Leyenda",
    "estadosFonte": "Estados de la fuente",
    "precondicoes": "Requisitos previos para la lectura",
    "origem": "Origen",
    "sistema": "Sistema",
    "responsavel": "Responsable",
    "responsavelId": "Identificador del responsable",
    "responsavelAjuda": "Opcional. Indique el identificador de un miembro activo con acceso a la empresa; se valida al guardar.",
    "ultimaLeitura": "Última lectura",
    "limite": "Límite de vigencia",
    "limiteCampo": "Límite de vigencia (horas)",
    "horas": "{{n}} horas",
    "estadoRotulo": "Estado",
    "motivo": "Motivo",
    "motivoAjuda": "Explicación del estado de la fuente; el sistema de origen no ofrece un diagnóstico detallado en esta pantalla.",
    "escopoAlterado": "El acceso cambió durante la acción. Actualice las fuentes antes de intentar de nuevo.",
    "semInformacao": "No informado",
    "semLeitura": "Todavía no se ha registrado una lectura.",
    "corte": "Corte {{data}} (Brasilia)",
    "cadastrar": "Registrar fuente",
    "alterar": "Editar fuente",
    "salvar": "Guardar fuente",
    "salvando": "Guardando fuente",
    "cancelar": "Cancelar",
    "salva": "Fuente guardada.",
    "registrarLeitura": "Registrar lectura",
    "registrandoLeitura": "Registrando lectura",
    "resultadoLeitura": "Resultado de la lectura",
    "processo": "Proceso",
    "escolhaResultado": "Elija el resultado",
    "leituraAjuda": "Registre el resultado ya obtenido. Esta acción usa la hora del servidor y no consulta el sistema de origen.",
    "leituraRegistrada": "Lectura registrada.",
    "fonteIndisponivel": "Fuente no disponible en su acceso.",
    "revogar": "Acceso a la fuente revocado",
    "revogarAjuda": "Al quitar esta marca, la fuente requiere una nueva lectura antes de estar actual.",
    "corrija": "Corrija los campos para guardar la fuente.",
    "voltar": "Volver al resumen",
    "fonteNaoConfigurada": "Configure una fuente y registre la primera lectura para este proceso.",
    "leituraBloqueada": "Configure y habilite la fuente antes de registrar una lectura.",
    dadoDeAjuda: 'Opcional. Indique la fecha efectiva del dato publicado por la fuente; déjela vacía cuando la fuente no la informe.',
    maturidadeAjuda: 'Opcional. Registre solo la madurez declarada por la fuente.',
    solicitarResponsavel: 'Solicitar responsable',
    solicitandoResponsavel: 'Registrando solicitud',
    solicitacaoDestino: 'Destino: administradores de este workspace. La solicitud queda registrada en Sala 360.',
    responsavelSolicitado: 'Solicitud registrada. Espere a que los administradores de este workspace definan al responsable.',
    solicitacaoFalhou: 'No se pudo registrar la solicitud. Intente de nuevo.',
    responsavelJaDefinido: 'Ya se definió un responsable. Actualice las fuentes para consultar la configuración.',
    pendenciasResponsavel: 'Solicitudes de responsable pendientes',
    pendenciaResponsavel: '{{n}} solicitud(es) de responsable pendiente(s)',
    abrirPendenciaResponsavel: '{{empresa}} · {{processo}} · {{n}} solicitud(es) pendiente(s)',
    maturidadeRotulo: { informado: 'Informado', conferido: 'Comprobado', conciliado: 'Conciliado' },
    "semResponsavel": "Responsable aún no definido.",
    "estado": {
      "nao_configurada": "No configurada",
      "sem_leitura": "Sin lectura"
    },
    "origemRotulo": {
      "erp": "ERP",
      "externo": "Sistema externo",
      "arquivo": "Archivo",
      "sem_fonte": "Sin fuente"
    },
    "motivoEstado": {
      "negado": "Los datos de esta empresa no están disponibles para su perfil.",
      "falha": "La última lectura falló. Los datos anteriores no deben tratarse como actuales.",
      "revogada": "El acceso a la fuente fue revocado. Habilítelo y registre una nueva lectura.",
      "com_diferenca": "La lectura informa una diferencia que debe comprobarse en el origen.",
      "vencida": "La última lectura superó el límite de vigencia configurado.",
      "parcial": "La lectura cubre solo parte de los datos de este proceso.",
      "atual": "La última lectura está dentro del límite de vigencia configurado.",
      "nao_configurada": "Falta configurar el origen de este proceso.",
      "sem_leitura": "La fuente está configurada, pero falta registrar la primera lectura."
    }
  },
  portfolio: {
    "titulo": "Mapa de los negocios",
    "mostrar": "Mostrar cobertura de los negocios",
    "ocultar": "Ocultar cobertura de los negocios",
    "negocio": "Negocio",
    "empresas": "Empresas en su acceso",
    "processos": "Procesos cubiertos",
    "cobertura": "Cobertura",
    "fonte": "Estado de la fuente",
    "institucional": "Institucional",
    "institucionalDescricao": "Información institucional, sin cifras operativas.",
    "vazio": "Ningún negocio disponible en este ámbito.",
    "nenhumaFonte": "Ningún proceso con fuente actual.",
    "faltam": "Sin fuente: {{lista}}",
    "parcialPermissao": "Parcial por permisos.",
    "quantidade": "{{n}} empresa(s) en su acceso",
    "estados": {
      "coberto": "Cubierto",
      "parcial": "Parcial",
      "sem_fonte": "Sin fuente",
      "fora_do_acesso": "Fuera de su acceso"
    }
  },
  demo: { selo: 'Demostración, datos sintéticos', verificando: 'Verificando el entorno' },
  resumo: {
    kicker: 'Sala 360',
    titulo: 'Resumen ejecutivo',
    perimetro: 'Empresas del workspace {{workspace}}: {{n}} de {{m}}',
    corte: 'Corte {{data}} (Brasilia)',
    contexto: 'Empresa',
    todas: 'Todas las empresas de su acceso',
    semEmpresas: 'Ninguna empresa en su acceso',
    janela: 'Ventana',
    dias: '{{n}} días',
    proposto: 'Fórmulas propuestas, pendientes de validación de contraloría',
  },
  kpi: {
    K01: 'Caja propia al corte',
    K02: 'Por pagar en la ventana',
    K03: 'Por cobrar vencido',
    K05: 'Decisiones abiertas',
    K04: "Caja proyectada (30 días)",
    origemK04: "Origen: Finanzas y Cuentas",
    origemK05: 'Origen: Sala 360',
    origemK01: 'Origen: Finanzas',
    origemK02: 'Origen: Cuentas y Compras',
    origemK03: 'Origen: Cuentas',
  },
  estado: {
    atual: 'Actual', parcial: 'Parcial', vencida: 'Vencida', com_diferenca: 'Con diferencia', revogada: 'Acceso revocado',
    falha: 'Fallo de lectura', negado: 'Fuera de su acceso', indisponivel: 'No disponible',
  },
  cartao: {
    semDado: 'sin dato',
    semRegistros: 'Sin registros: la fuente informa cero',
    parcela: 'Parte conocida',
    faltam: 'Falta: {{lista}}',
    indisponivel: 'Sin fuente para este indicador.',
    negado: 'Parcial por permisos.',
    falha: 'No fue posible leer este indicador.',
    vencida: 'Dato del {{data}}, fuera del límite.',
    naoConciliado: 'No conciliado',
    pendenteClassificacao: 'Pendiente de clasificación',
    foraDoK01: 'Restringidas y administradas (fuera del K01)',
    pedidosSemTitulo: 'Pedidos sin título (fuera del total)',
    pendenciaMapeamento: 'Mapeo pendiente: {{n}} título(s) sin empresa',
    tentar: 'Intentar de nuevo',
    cobertura: 'Cobertura: {{n}} de {{m}} empresas',
    naoAgregavel: "No agregable: cobertura insuficiente para la proyección completa.",
    verFontes: "Ver fuentes y cobertura",
    projecao: "Previsto en 30 días",
    formulaProjecao: "Saldo propio inicial + entradas previstas − salidas previstas",
    abertura: "Saldo propio inicial",
    entradas: "Entradas previstas",
    saidas: "Salidas previstas",
    vencidosProjecao: "Vencidos abiertos incluidos en el primer período: {{n}}",
  },
  processo: { bancos: 'bancos', natureza: 'naturaleza de las cuentas', pagar: 'cuentas por pagar', pedidos: 'pedidos de compra', receber: 'cuentas por cobrar', decisoes: 'decisiones' },
  compromissos: {
    titulo: 'Compromisos',
    pagar: 'Por pagar',
    receber: 'Por cobrar',
    numero: 'Número',
    empresa: 'Empresa',
    parceiro: 'Contraparte',
    vencimento: 'Vencimiento',
    valor: 'Saldo',
    vinculo: 'Pedido',
    confirmado: 'Pedido {{numero}}',
    ausente: 'Sin pedido',
    vencido: 'Vencido',
    grupo: 'Grupo (sin empresa)',
    vazio: 'La fuente informa que no hay compromisos en esta ventana.',
    exportar: 'Exportar CSV',
    mais: 'Cargar más',
    pedidoSemTitulo: 'Pedido sin título',
    previsao: 'Previsión {{data}}',
    abrir: 'Abrir compromiso {{numero}}',
  },
  detalhe: {
    kicker: 'Compromiso',
    voltar: 'Volver al resumen',
    cadeia: 'Pedido, título y pago',
    pedido: 'Pedido',
    titulo: 'Título',
    pagamento: 'Pago',
    noConfirmado: 'confirmado',
    noAusente: 'no vinculado',
    emissao: 'Emisión',
    total: 'Total',
    pago: 'Pagado',
    saldo: 'Saldo',
    estado: 'Estado',
    descricao: 'Descripción',
    restrito: 'Parte de la información no está disponible para su perfil.',
    evidencias: 'Ver evidencias',
    decidir: 'Registrar decisión sobre este título',
    baixa: 'Pago el {{data}}',
    estados: { em_aberto: 'Abierto', parcial: 'Parcial', pago: 'Pagado', cancelado: 'Cancelado', renegociado: 'Renegociado' },
  },
  evidencias: {
    kicker: 'Evidencias',
    titulo: 'Evidencias de {{numero}}',
    vazio: 'Ninguna evidencia vinculada a este compromiso.',
    restritas: 'Hay evidencias que no están disponibles para su perfil.',
    registro: 'Registro de origen',
    anexo: 'Adjunto',
    abrir: 'Abrir',
    baixar: 'Descargar',
    voltar: 'Volver al compromiso',
    entidades: { 'contas.documento': 'Título en Cuentas', 'compras.pedido': 'Pedido en Compras' },
    semVisualizacao: 'Este formato no se abre aquí. Use Descargar.',
    falhaLeitura: 'No fue posible abrir el adjunto.',
    suporte: 'Código para soporte: {{codigo}}',
    fechar: 'Cerrar',
  },
  decisoes: {
    kicker: 'Decisión', voltar: 'Volver a la cola', recortes: 'Vistas de la cola', registrar: 'Registrar decisión', registrada: 'Decisión registrada.',
    recorte: { minhas: 'Mías', abertas_por_mim: 'Abiertas por mí', encerradas: 'Cerradas' },
    vazio: { minhas: 'Ninguna decisión abierta bajo su responsabilidad.', abertas_por_mim: 'Ninguna decisión abierta por usted.', encerradas: 'Ninguna decisión cerrada.' },
    vencidaHa_one: 'Vencida hace {{count}} día', vencidaHa_other: 'Vencida hace {{count}} días',
    contadorVencidas_one: '{{count}} decisión vencida al inicio de la cola', contadorVencidas_other: '{{count}} decisiones vencidas al inicio de la cola',
    objeto: { 'contas.documento': 'Título', 'compras.pedido': 'Pedido de compra', livre: 'Decisión libre' },
    estado: { aberta: 'Abierta', em_andamento: 'En curso', concluida: 'Concluida', cancelada: 'Cancelada' },
    evento: { criada: 'Registrada', em_andamento: 'En curso', concluida: 'Concluida con resultado confirmado', cancelada: 'Cancelada', prazo_vencido: 'Plazo vencido' },
    acao: { andamento: 'Marcar en curso', concluir: 'Concluir', cancelar: 'Cancelar decisión' },
    responsavel: 'Responsable', solicitante: 'Abierta por', prazo: 'Plazo', titulo: 'Título', oQue: 'Qué se decidió', sobre: 'Sobre',
    estadoRotulo: 'Estado', resultado: 'Resultado confirmado', motivo: 'Motivo', obrigatorio: 'obligatorio', conduzir: 'Conducir la decisión',
    ajudaConcluir: 'Concluir solo está disponible con el resultado confirmado completado.', historico: 'Historial',
    escolha: 'Elija el responsable', ninguem: 'Nadie con acceso a este objeto', prazoPassado: 'El plazo no puede ser anterior a hoy.',
    salvar: 'Registrar', salvando: 'Registrando', cancelarForm: 'Cancelar', naoEncontrada: 'Decisión no encontrada.',
    conflito: 'Otra persona acaba de cambiar esta decisión. La pantalla se actualizó.', corrija: 'Corrija para registrar:', proximas: 'Decisiones más próximas', semAbertas: 'Ninguna decisión abierta.', verTodas: 'Ver todas las decisiones', vencidas: 'Vencidas: {{n}}',
  },
  chatter: { prazoVencido: 'Plazo vencido: {{titulo}}' },
  erros: {
    prazo_no_passado: 'El plazo no puede ser anterior a hoy.', titulo_invalido: 'Indique un título de hasta 160 caracteres.',
    decisao_invalida: 'Describa la decisión (hasta 2000 caracteres).', responsavel_sem_acesso: 'El responsable debe tener acceso a la empresa del objeto.',
    objeto_indisponivel: 'Objeto no encontrado.', empresa_indisponivel: 'Empresa no encontrada.',
    fonte_sem_configuracao: "Configure y habilite la fuente antes de registrar una lectura.",
    limite_invalido: "Indique un número entero positivo de horas.",
    sistema_invalido: "Indique un sistema de hasta 160 caracteres.",
    origem_invalida: "Elija un origen válido.",
    processo_invalido: "Elija un proceso de Sala 360.",
    leitura_invalida: "Elija un resultado de lectura válido.",
    dado_de_invalido: 'Indique una fecha válida en formato año-mes-día.', maturidade_invalida: 'Elija una madurez válida.',
    fonte_nao_encontrada: "Fuente no disponible en su acceso.",
  },
  erro: { semPermissao: 'No tiene acceso a la Sala 360.', naoEncontrado: 'Compromiso no encontrado.' },
};

export const dicionario = { pt, en, es };
